import { makeObservable, observable, action } from "mobx";

class SamplesDiagnosticPopupModel {
  displayMessages = false;
  allMessages: string[] = [];
  originalConsoleWarn: any = null;
  originalConsoleError: any = null;
  ref: React.Ref<HTMLDivElement> | null = null;

  constructor() {
    makeObservable(this, {
      displayMessages: observable,
      allMessages: observable,
      addWarning: action,
      showWarnings: action,
      startMessageListening: action,
      stopMessageListening: action
    });
  }

  startMessageListening() {
    this.resetWarnings();

    if (!this.originalConsoleWarn) {
      this.originalConsoleWarn = console.warn;
    }
    if (!this.originalConsoleError) {
      this.originalConsoleError = console.error;
    }

    // Override console.warn
    console.warn = (...args) => {
      // Call the original console.warn method
      this.originalConsoleWarn.apply(console, args);
      const message = args.join(' ')
      // Capture the warning message
      this.addWarning(message);
    };

    console.error = (...args) => {
      // Call the original console.warn method
      this.originalConsoleError.apply(console, args);

      const message = args.join(' ')
      // Capture the warning message
      this.addWarning(message);
    };
  }

  stopMessageListening() {
    // Restore the original console.warn method
    if (this.originalConsoleWarn) {
      console.warn = this.originalConsoleWarn;
    }
    if (this.originalConsoleError) {
      console.error = this.originalConsoleError;
    }
  }
  resetWarnings() {
    this.allMessages = [];
  }


  addWarning(message: string) {
    // Use MobX action to update observable state
    this.allMessages = [...this.allMessages, message];
  }

  showWarnings() {
    this.displayMessages = true;
  }
}


const samplesDiagnosticPopupModel = new SamplesDiagnosticPopupModel();
export default samplesDiagnosticPopupModel;
